

import { Mixins, Component, VModel } from 'vue-property-decorator';
import CustomerSessionExpiredDialog from './CustomerSessionExpiredDialog.vue';
import IBDialogSms from "@/components/IBDialog/IBDialogSms.vue";
import DigitalSignPasswordDialog from "@/feature/Auth/components/DigitalSignPasswordDialog.vue";
import AuthDigitalSign from '../mixins/AuthDigitalSign';
import { Getter } from 'vuex-class';
import { DigitalSign } from '../types/digital-sign';
import { IProfileEntity } from '@/models/modules/profile/interface';
import { PROFILE_MODULE_NAME } from '@/store/modules/profile';
import PaymentRequirementsIncomingChecker from '@/feature/PaymentRequirements/mixins/Incoming/Handler/PaymentRequirementsIncomingChecker';

@Component({
	components: {
		CustomerSessionExpiredDialog,
		IBDialogSms,
		DigitalSignPasswordDialog,
	}
})
export default class CustomerSessionExpired extends Mixins(
	AuthDigitalSign,
	PaymentRequirementsIncomingChecker
) {

	@VModel({ type: Boolean })
	model!: boolean

	@Getter('digitalSign', { namespace: PROFILE_MODULE_NAME })
	readonly digitalSign!: DigitalSign

	@Getter('profile', { namespace: PROFILE_MODULE_NAME })
	readonly profile!: IProfileEntity

	onReAuth() {
		this.onSelectDigitalSign({
			flCrmId: this.profile?.flCrmId,
			ulCrmId: this.profile?.ulCrmId,
			mfoUl: this.profile?.mfoUl,
			...(this.digitalSign || {})
		});

		this.passwordDialog = true;
	}

	async onSignedIn() {
		this.model = false;

		this.checkHasPaymentRequirementsIncomingAndShowDialog();
	}

	async onBeforeSubmitPassword(digitalSign?: DigitalSign) {
		this.selectedDigitalSign = digitalSign;

		this.setProfileDigitalSign(digitalSign);
		await this.onSubmitDigitalSignPassword();
	}

}

